import React from "react";

import { useParams } from "react-router-dom";

import athletes from "../athletes.json";
import "./Athlete.css";

const Athlete = (props) => {
  let { name } = useParams();
  const athlete = athletes[name];

  let twitter = null;
  if (athlete["twitter"]) {
    let twitter_handle = athlete["insta"].split("/");
    twitter_handle = twitter_handle[twitter_handle.length - 1];
    twitter = (
      <p>
        Twitter:
        <a href={athlete["twitter"]} className="socialIcon">
          @{twitter_handle}
        </a>
      </p>
    );
  }

  let insta = null;
  if (athlete["insta"]) {
    let insta_handle = athlete["insta"].split("/");
    insta_handle = insta_handle[insta_handle.length - 1];
    insta = (
      <p>
        Instagram:
        <a href={athlete["insta"]} className="socialIcon">
          @{insta_handle}
        </a>
      </p>
    );
  }
  let social = null;
  if (twitter || insta) {
    social = (
      <div className="athleteSocial">
        {twitter}
        {insta}
      </div>
    );
  }

  return (
    <div className="Athlete">
      <div className="AthleteImgContainer">
        <img src={athlete["img"]} alt={athlete["name"]} />
      </div>

      <div className="athleteInfo">
        <h2>
          {athlete["name"]}{" "}
          {/* <img
            className="flagIcon"
            src={athlete["flag"]}
            alt={athlete["country"]}
          /> */}
        </h2>
        <h5>Country</h5>
        <p>{athlete["country"]}</p>
        <h5>Alma Mater</h5>
        <p>{athlete["college"]}</p>

        <h5>Personal Best</h5>
        {athlete["PRs"].map((pr) => (
          <p>{pr}</p>
        ))}
        <h5>Career Highlights</h5>
        {athlete["highlights"].map((highlight) => (
          <p>{highlight}</p>
        ))}
        <h5>Favorite Shoe</h5>
        <p>{athlete["shoe"]}</p>
        <h5>Social</h5>
        {social}
      </div>
    </div>
  );
};

export default Athlete;
